import emailjs from 'emailjs-com'
import React, { useState } from 'react'
import Button from '../../components/button/button'
import InputFields from './components/inputFields'


import './styles/formStyle.css'

export default function Forms() {

  let [forms, setForms] = useState({
    name: '',
    company_email: '',
    company_name: '',
    website: '',
    phone_number: '',
    message: '',
  });

  const inputLabels = [
    { label: "ชื่อ - นามสกุล", required: true, translation:'translation:name surname' },
    { label: "ชื่ออีเมลบริษัท", required: true, translation:'translation:company email' },
    { label: "ชื่อบริษัท", required: true, translation:'translation:company name' },
    { label: "ชื่อเว็บไซต์", required: false, translation:'translation:website name' },
    { label: "เบอร์โทรศัพท์", required: false, translation:'translation:tell' },
    { label: "ข้อความ", required: false, translation:'translation:message' },
  ]

  const onSubmitHandler = () => {
    emailjs.send('gmail', 'silverman_app', forms, 'user_Qf3oGNWq56fk0qcf6CIjJ')
      .then((response) => {
        console.log('SUCCESS ', response.status, response.text)
      }, (err) => {
        console.log('FAILED... ', err)
      })
    reset()
  }

  const onChangeHander = (e) => {
    e.preventDefault();
    setForms({
      ...forms,
      [e.target.name]: e.target.value
    })
  }
  const reset = () => {
    setForms({
      name: '',
      company_email: '',
      company_name: '',
      website: '',
      phone_number: '',
      message: '',
    })
  }



  return (
    <div
      style={{ width: '100%' }} className="form-container">
      <InputFields data={inputLabels[0]} value={forms.name} name="name" onChange={text => onChangeHander(text)} />
      <InputFields data={inputLabels[1]} value={forms.company_email} name="company_email" onChange={text => onChangeHander(text)} />
      <InputFields data={inputLabels[2]} value={forms.company_name} name="company_name" onChange={text => onChangeHander(text)} />
      <InputFields data={inputLabels[3]} value={forms.website} name="website" onChange={text => onChangeHander(text)} />
      <InputFields data={inputLabels[4]} value={forms.phone_number} name="phone_number" onChange={text => onChangeHander(text)} />
      <label className="input-label" style={{ paddingLeft: 10, paddingRight: 10, margin: 0 }}>{inputLabels[5].label}</label>
      <textarea className="input-field"
        style={{ marginLeft: 10, marginRight: 10, height: 100 }}
        value={forms.message} name="message"
        onChange={text => onChangeHander(text)}
      />
      <Button title="Become Partner" height={45} style={{ paddingLeft: 10, paddingRight: 10 }} onClick={onSubmitHandler} />
    </div>
  )
}